import { render, staticRenderFns } from "./jx.vue?vue&type=template&id=f4b3601e&scoped=true"
import script from "./jx.vue?vue&type=script&lang=js"
export * from "./jx.vue?vue&type=script&lang=js"
import style0 from "./jx.vue?vue&type=style&index=0&id=f4b3601e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b3601e",
  null
  
)

export default component.exports